globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Emailing = appCustomerSpace.Modals.Emailing || {};

appCustomerSpace.Modals.Emailing.ScheduleNewsletter = (function(superClass) {

  utils.extend(ScheduleNewsletter, superClass);

  function ScheduleNewsletter() {
    return ScheduleNewsletter.__super__.constructor.apply(this, arguments);
  }

  $.extend(ScheduleNewsletter.prototype, {
    init: function() {
      this._initRadioButtons()
      this._initDatePicker()
      return ScheduleNewsletter.__super__.init.apply(this, arguments);
    },
    _initRadioButtons: function () {
      $('#scheduled_mode-wrapper').find('input').on('click', function(e) {
        if (e.currentTarget.value == 'later') {
          $("#date-wrapper").show()
        } else {
          $("#date-wrapper").hide()
        }
      })
    },
    _initDatePicker: function () {
      var Single = appCustomerSpace.LimitlessPlugins.DatePickers.Single;
      this.$html.find('[data-js-schedule-datepicker]').each(function() {
        new Single($(this));
      })
    },
    updateView(data) {
      if (data.html) {
        $(`.newsletter-panel[data-uniq-key=${data.newsletter_uniq_key}]`).replaceWith($(data.html))
      }
    }
  });

  return ScheduleNewsletter;

})(appCustomerSpace.Modal);
